export default __webpack_public_path__ + "static/media/dominos.4ab48b3a.png";